module.exports = __webpack_public_path__ + "static/img/2025年历-7.3351dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-7.png
// module id = +/MS
// module chunks = 3